module.exports = __webpack_public_path__ + "img/google.08243484.svg";